import { MenuItemCard } from "./MenuItemCard";
import { MenuItem, CartItem } from "@/types";

interface MenuGridProps {
  items: MenuItem[];
  onAddToCart: (item: CartItem) => void;
  cartItems: CartItem[];
  onUpdateQuantity: (itemId: string, quantity: number) => void;
}

export function MenuGrid({
  items,
  onAddToCart,
  cartItems,
  onUpdateQuantity,
}: MenuGridProps) {
  const getCartQuantity = (itemId: string) => {
    const cartItem = cartItems.find((item) => item.id === itemId);
    return cartItem?.quantity || 0;
  };

  if (items.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="text-gray-400 mb-4">
          <svg
            className="w-16 h-16 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.47-.881-6.08-2.33"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          No items found
        </h3>
        <p className="text-gray-500">
          Try adjusting your search or filter to find what you're looking for.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item: any) => (
        <MenuItemCard
          key={item.id}
          item={item}
          onAddToCart={onAddToCart}
          cartQuantity={getCartQuantity(item.id)}
          onUpdateQuantity={onUpdateQuantity}
          categoryId={item.categoryId}
        />
      ))}
    </div>
  );
}
